import React, { useState, useCallback, useEffect, useLayoutEffect, useRef } from 'react';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  IconButton,
  Box,
  InputAdornment,
  Popover,
  TextField,
  Button,
  Grow,
  Divider,
  Tooltip,
  Menu,
  MenuItem,
  CardMedia,
  useMediaQuery,
  Avatar,
} from '@mui/material';
import {
  EmojiEmotions,
  Send,
  Delete,
  Edit,
  MoreVert,
  StarBorder,
  StarOutlined,
  VisibilityOutlined,
  InsertCommentOutlined,
  ThumbUpAltOutlined,
  ThumbUpSharp,
  ArrowBack,
  ArrowBackIos,
} from '@mui/icons-material';
import EmojiPicker from 'emoji-picker-react';
import UserAvatar from '../../../common/UserAvatar';
import AttachAvatar from '../../../common/AttachAvatar';
import { capitalizeFirstLetter } from '../../../utils/capitalizeFirstLetter';
import empty from './nocomments.jpg';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentUserEmpCode, setGnnStatus } from '../../Auth/authSlice';
import {
  useCommentNewsMutation,
  useDeleteGnnCommentMutation,
  useDeleteNewsMutation,
  useGetNewsByIdQuery,
  useLikeNewsMutation,
  useMarkAsTop5NewsMutation,
  useUnlikeNewsMutation,
  useViewNewsMutation,
} from '../gnnApiSlice';
import { variants } from '../../../variants/variants';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAbility } from '@casl/react';
import { useTheme } from '@emotion/react';
import { AbilityContext } from '../../../context/Ability';
import { formatDateWithSuffix } from '../../../utils/dateUtils';
import defaultimg from './default.png';
import { Public } from '@mui/icons-material';
import { ItemLoader } from './GnnSkeleton';
import linkwaylogo from '../../../assets/Linkway/LinkwayLogo.png';
import GNXTLogo from '../../../assets/GatewayLogo/G_NXTLogo.png';
import useSocket from '../../../hooks/sockets/useSocket';
import NewsDetail from './NewsDetail';
import { Link, Element, scroller } from 'react-scroll';
import PostNewsDialog from './PostNewsDialog';
import Carousel from 'react-material-ui-carousel';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import gatewayLogo from '../../../assets/gatewaylogo.jpeg';
import { border } from '@mui/system';
import AttachmentGallery from '../../../common/Utility/AttachmentGallery ';
const NewsDescription = ({ description }) => {
  const [showMore, setShowMore] = useState(false);
  const MAX_LENGTH = 200; // Maximum number of characters to display before "Show More"

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  const truncatedDescription =
    description?.length > MAX_LENGTH ? description.substring(0, MAX_LENGTH) + '...' : description;

  return (
    <Typography variant="body2" paragraph>
      <span
        style={{ whiteSpace: 'pre-wrap' }}
        dangerouslySetInnerHTML={{ __html: showMore ? description : truncatedDescription }}
      />
      {description?.length > MAX_LENGTH && (
        <Button
          onClick={toggleShowMore}
          variant="text"
          size="small"
          style={{
            background: 'none',
            display: 'inline',
            textTransform: 'none',
            padding: 0,
            minWidth: 'auto',
            border: 'none',
            color: 'grey',
          }}
        >
          ...{showMore ? 'collapse' : 'see more'}
        </Button>
      )}
    </Typography>
  );
};
const NewsComments = ({ Id }) => {
  // const theme = useTheme();

  const { id } = useParams();
  const newsId = id || Id;
  const { data: newsData, isLoading, isError } = useGetNewsByIdQuery(newsId);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl1, setAnchorEl1] = useState(null);
  const [hover, setHover] = useState(false);
  const [likesModalOpen, setLikesModalOpen] = useState(false);
  const [openPhoto, setOpen] = useState(false);
  const [photoSrc, setPhotoSrc] = useState(null);
  const [deleteComment] = useDeleteGnnCommentMutation();
  const user = useSelector(selectCurrentUser);
  const [newsDeleted, setNewsDeleted] = useState(false);
  const [comment] = useCommentNewsMutation();
  const { socket } = useSocket();
  const [likeNews] = useLikeNewsMutation();
  const [unlikeNews] = useUnlikeNewsMutation();
  const [deleteNews] = useDeleteNewsMutation();
  const [markAsTop5News] = useMarkAsTop5NewsMutation();
  const [currentLikes, setCurrentLikes] = useState([]);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [news, setNews] = useState([]);
  const dispatch = useDispatch();
  const [viewNews, { isError: viewError }] = useViewNewsMutation();
  const [sendDisable, setSendDisable] = useState(false);
  const mediaFiletypes = /mp4|mkv|webm|mov|avi|wmv|flv|3gp/;
  const inputRef = useRef(null);
  useLayoutEffect(() => {
    if (!isLoading && newsData) {
      setNews(newsData);
    }
  }, [newsData, isLoading]);
  console.log('News :-', newsData);
  // useEffect(() => {
  //   console.log(newsData, 'NEWS', 'isLoading', isLoading, 'Condition', !isLoading && (!newsData || newsData.length === 0));

  //   if (!isLoading && (!newsData || newsData.length === 0)) {
  //     console.log("Need to Navigate on gnn");
  //     navigate('/home/announcement/gnn');
  //   }
  // }, [newsData, isLoading]);

  const empCode = useSelector(selectCurrentUserEmpCode);
  const ability = useAbility(AbilityContext);
  // const [anchorEl, setAnchorEl] = useState(null);
  const [commentData, setCommentData] = useState({
    empCode: empCode,
    comment: '',
  });
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const { pathname } = useLocation();
  const path = isMobile ? pathname.split('/')[pathname.split('/').length - 1].split('-')[0] : pathname.split('/')[3];
  const navigate = useNavigate();
  const handleMenuOpen = (event) => {
    event.stopPropagation();
    setAnchorEl1(event.currentTarget);
  };
  const isNewsLiked = (news) => news[0]?.likes?.some((like) => like?.empCode === user?.empCode);
  const handleMenuClose = (event) => {
    event.stopPropagation();
    setAnchorEl1(null);
  };

  const handleEmojiPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const empCodeData = {
    empCode: empCode,
  };

  const incrementViewCount = async () => {
    try {
      await viewNews({ id, empCodeData });
    } catch (error) {
      console.error('Error incrementing view count:', error);
    }
  };

  useEffect(() => {
    if (!viewError) {
      incrementViewCount();
    } else {
      console.error('Error incrementing view count:', viewError);
    }
  }, [viewError]);

  console.log('component rendered');
  useEffect(() => {
    dispatch(setGnnStatus(false));

    socket.on('new-count', (message) => {
      console.log('Received new count update from socket:', message);

      const updatedNewsData = news?.map((item) =>
        item._id === message._id ? { ...item, likes: message.likes, viewCount: message.viewCount } : item
      );

      console.log('Updated news state with new data:', updatedNewsData);
      setNews(updatedNewsData);
    });

    return () => {
      console.log('Cleaning up socket listener for new-count');
      socket.off('new-count');
    };
  }, [dispatch, socket, news]); // Ensure 'news' and other dependencies are correctly set

  console.log('view count', news);

  const handleEmojiClick = (emojiObject) => {
    const newText = commentData.comment + emojiObject.emoji;
    setCommentData((prevState) => ({
      ...prevState,
      comment: newText,
      empCode: user?.empCode,
    }));
    setAnchorEl(null);
  };

  const handleCommentChange = (e) => {
    const { name, value } = e.target;
    setCommentData((prevState) => ({
      ...prevState,
      comment: value,
      empCode: empCode,
    }));
  };
  const handleCommentPost = async (id) => {
    try {
      setSendDisable(true);
      const response = await comment({ id, commentData });
      setCommentData({
        comment: '',
      });
      scrollToComment(response?.data?._id); // Scroll to the newly added comment
      setSendDisable(false);
    } catch (error) {
      console.error('Error posting comment:', error);
    }
  };

  const scrollToComment = (id) => {
    scroller.scrollTo(`comment-${id}`, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: -50, // Offset for sticky headers, etc.
    });
  };
  const handleKeyPress = useCallback(
    (event) => {
      if (event.key === 'Enter') {
        const trimmedFeedback = commentData.comment.trim();
        if (!event.shiftKey) {
          event.preventDefault();
          if (trimmedFeedback) {
            handleCommentPost(news[0]?._id);
            setCommentData({ comment: '' });
          }
        } else {
          setCommentData((prevData) => ({
            ...prevData,
            comment: event.target.value,
          }));
        }
      }
    },
    [commentData, handleCommentPost, news]
  );

  if (isError) {
    <div>Error fetching news</div>;
  }

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.5)', // Adjust the transparency level
          backdropFilter: 'blur(5px)', // Optional: Adds a blur effect to the background
        }}
      >
        {/* <Avatar variant={'rounded'} src={GNXTLogo} sx={{ height: 50, width: 50 }} /> */}
        {/* <img src={GNXTLogo} style={{ height: 70, width: 150 }} /> */}
        <Typography sx={{ mt: 2 }}>Loading...</Typography>
      </Box>
    );
  }

  if (!isLoading && (!newsData || newsData.length === 0)) {
    console.log('Need to Navigate on gnn');
    return navigate('/home/announcement/gnn');
  }

  const handleLikeClick = async (event, id) => {
    event.stopPropagation();
    try {
      await likeNews({ id, empCodeData: { empCode } });
    } catch (error) {
      console.error('Error liking news:', error);
    }
  };

  const handleUnlikeClick = async (event, id) => {
    event.stopPropagation();
    try {
      await unlikeNews({ id, empCodeData: { empCode } });
    } catch (error) {
      console.error('Error unliking news:', error);
    }
  };

  const handleDeleteClick = async (event, id) => {
    event.stopPropagation();
    try {
      await deleteNews(id).unwrap();
      setNewsDeleted(true);
    } catch (error) {
      console.error('Error deleting news:', error);
    }
  };

  const handleLikesClick = (event, likes) => {
    event.stopPropagation();
    setCurrentLikes(likes);
    setLikesModalOpen(true);
  };

  const handleCardClick = (id) => {
    navigate(`${id}`);
  };

  const handleEditClick = (event, news) => {
    event.stopPropagation();
    setSelectedNews(news);
    setEditDialogOpen(true);
    setIsEdit(true);
  };

  const handleMarkAsTop5Click = async (event, id) => {
    event.stopPropagation();
    try {
      await markAsTop5News({ id });
    } catch (error) {
      console.error('Error marking news as top 5:', error);
    }
  };

  const handleDeleteComment = async (newsId, commentId) => {
    try {
      await deleteComment({ newsId, commentId }).unwrap();
    } catch (error) {
      console.error('Error deleting comment:', error);
    }
  };

  const handleOpenDialog = (src) => {
    setPhotoSrc(src);
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const open = Boolean(anchorEl);

  // if (news?.length === 0) {
  //   return <Typography>No news found.</Typography>;
  // }
  return !isSm ? (
    <Grid sm={12} xs={12} item height={`calc(100vh - 200px)`}>
      <NewsDetail />
    </Grid>
  ) : (
    <Grid sm={12} xs={12} item>
      <Grid item sm={12} xs={12} sx={{ overflow: 'auto', height: '82vh' }}>
        <Grid
          sx={{
            // marginBottom: '3rem',
            // boxShadow: 'rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px',
            background: 'white',
            // height: '100%',
            // width: isSm ? '100vw' : '30vw',
            display: 'flex',
            flexDirection: 'column',
            cursor: 'default',
            // '&:hover': {
            //   boxShadow: 'rgba(136, 165, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px',
            // },
          }}
          // onClick={() => handleCardClick(news?._id)}
        >
          <CardContent sx={{ flexGrow: 1, padding: 0 }}>
            <Grid sx={{ display: 'flex', mt: 1, mb: 2 }}>
              {/* <IconButton
              onClick={() => {
                navigate(-1);
              }}
            >
              <ArrowBackIos sx={{ml:0, fontSize: '15px' }} />
            </IconButton> */}
              <Avatar
                sx={{ width: 35, height: 35, mr: 1, img: { objectFit: 'cover', objectPosition: 'top' } }}
                src={news[0]?.authorUserPhoto || gatewayLogo}
              />

              <Grid sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <Grid sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', float: 'right' }}>
                  <Typography sx={{ color: 'black', fontSize: '13px', fontWeight: 'bold' }}>
                    {news[0]?.authorName.trim() || 'Gateway Group Of Companies'}
                  </Typography>
                  <Box sx={{ display: 'flex' }}>
                    {news[0]?.categories != 'Internal Posts' ? (
                      <>
                        {ability.can('update', 'Gnn') ||
                        ability.can('manage', 'Gnn') ||
                        ability.can('read', 'Admin') ? (
                          <>
                            {news[0]?.top5News ? (
                              <Tooltip title="Remove from Top 5 News">
                                <IconButton
                                  size="small"
                                  onClick={(event) => handleMarkAsTop5Click(event, news[0]?._id)}
                                  sx={{ padding: 0 }}
                                >
                                  <StarOutlined sx={{ fontSize: '17px', fontWeight: '500', mr: 1 }} />
                                </IconButton>
                              </Tooltip>
                            ) : (
                              <Tooltip title="Add to Top 5 News">
                                <IconButton
                                  size="small"
                                  onClick={(event) => handleMarkAsTop5Click(event, news[0]?._id)}
                                  sx={{ padding: 0 }}
                                >
                                  <StarBorder sx={{ fontSize: '17px', fontWeight: '500', mr: 1 }} />
                                </IconButton>
                              </Tooltip>
                            )}
                          </>
                        ) : null}
                      </>
                    ) : (
                      <></>
                    )}
                    {/* {(news[0]?.empCode === empCode || ability.can('manage', 'Gnn') || ability.can('read', 'Admin')) && (
                      <Grid container justifyContent="flex-end" alignItems="center">
                        <Tooltip title="Options">
                          <IconButton size="small" onClick={handleMenuOpen} sx={{ padding: 0.2, mr: 1 }}>
                            <MoreVert sx={{ fontSize: '15px', fontWeight: '500', color: 'grey' }} />
                          </IconButton>
                        </Tooltip>
                        <Menu anchorEl={anchorEl1} open={Boolean(anchorEl1)} onClose={handleMenuClose}>
                          <MenuItem onClick={(event) => handleEditClick(event, news)}>
                            <Edit sx={{ fontSize: '15px', fontWeight: '500', color: 'grey', mr: 1 }} /> Edit
                          </MenuItem>
                          <MenuItem onClick={(event) => handleDeleteClick(event, news._id)}>
                            <Delete sx={{ fontSize: '15px', fontWeight: '500', color: 'grey', mr: 1 }} /> Delete
                          </MenuItem>
                        </Menu>
                      </Grid>
                    )} */}
                  </Box>
                </Grid>
                <Grid sx={{ display: 'flex', flexDirection: 'row' }}>
                  <Typography sx={{ color: 'grey', fontSize: '11px', lineHeight: '20px' }}>
                    {formatDateWithSuffix(new Date(news[0]?.createdAt).toLocaleDateString('en-GB'))}
                  </Typography>{' '}
                  <Typography sx={{ color: 'grey', fontSize: '11px', ml: 0.4, mr: 0.4, lineHeight: '20px' }}>
                    •
                  </Typography>{' '}
                  {news[0]?.categories == 'Public news' ? (
                    <>
                      <Public
                        sx={{
                          fontWeight: 'bold',
                          color: 'grey',
                          fontSize: '11px',
                          mt: 0.6,
                          lineHeight: '20px',
                          mr: 0.4,
                        }}
                      />{' '}
                    </>
                  ) : (
                    <></>
                  )}
                  <Typography
                    sx={{
                      color: 'grey',
                      fontSize: '12px',
                      ml: news.categories == 'Public news' ? '0.4' : '0',
                      lineHeight: '20px',
                    }}
                  >
                    {news[0]?.categories.join(', ')}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {/* <Typography variant="subtitle1" sx={{ mb: 0.3 }}>
              {capitalizeFirstLetter(news[0]?.title)}
            </Typography> */}
            <div style={{ width: '100%', wordBreak: 'break-word' }}>
              <NewsDescription description={news[0]?.description} />
            </div>

            {/* <>
              {news[0]?.categories != 'Internal Posts' ? (
                <></>
              ) : (
                <Grid sx={{ display: 'flex', mt: 1 }}>
                  <Typography variant="body2" sx={{ color: 'grey' }}>
                    Posted by {news[0]?.authorName}
                  </Typography>
                  <UserAvatar
                    sx={{ width: 19, height: 19, mr: 1, ml: 1 }}
                    src={news[0]?.authorUserPhoto}
                    alt="Avatar"
                  />
                </Grid>
              )}
            </> */}
          </CardContent>
          {/* <CardMedia
      component={
        news[0]?.attachments[0] ? (mediaFiletypes.test(news[0]?.attachments[0]?.split('.').pop()) ? 'video' : 'img') : 'img' // Default to 'img' if no attachment
      }
      src={
        news[0]?.attachments[0]
          ? mediaFiletypes.test(news?.attachments[0]?.split('.').pop())
            ? `${process.env.REACT_APP_PUBLIC_UPLOADS_URL}${news?.attachments[0]}`
            : `${process.env.REACT_APP_PUBLIC_UPLOADS_URL}${news?.attachments[0]}`
          : defaultimg // Replace 'default_image_url' with your actual default image URL
      }
      image={
        !news[0]?.attachments[0]
          ? defaultimg // Replace 'default_image_url' with your actual default image URL
          : undefined
      }
      alt="News"
      sx={{ height: '18vh', objectFit: 'cover' }}
      controls={
        news[0]?.attachments[0]
          ? mediaFiletypes.test(news[0]?.attachments[0]?.split('.').pop())
            ? true
            : undefined
          : undefined
      }
    /> */}

          {/* <div>
            {news.map((item, index) => (
              <CardMedia
                key={item._id}
                component={
                  item.attachments[0]
                    ? mediaFiletypes.test(item.attachments[0].split('.').pop())
                      ? 'video'
                      : 'img'
                    : 'img'
                }
                src={
                  item?.attachments[0]
                    ? `${process.env.REACT_APP_PUBLIC_UPLOADS_URL}${item?.attachments[0]}`
                    : defaultimg
                }
                image={!item.attachments[0] ? defaultimg : undefined}
                alt='News'
                sx={{ height: '18vh', objectFit: 'cover', padding: 0 }}
                controls={
                  item.attachments[0] && mediaFiletypes.test(item.attachments[0].split('.').pop()) ? true : undefined
                }
              />
            ))}
          </div> */}
          {news[0]?.attachments?.length > 0 ? (
            <div>
              {news?.map((item) => (
                <Box key={item._id} sx={{ position: 'relative' }}>
                  <AttachmentGallery
                    attachments={news[0]?.attachments || []}
                    defaultimg={defaultimg}
                    isDetailScreen={true}
                  />
                </Box>
              ))}
            </div>
          ) : null}
          <Box
            sx={{
              display: 'flex',
              gap: '3px',
              mt: 'auto',
              alignItems: 'center',
              backgroundColor: 'white',
              border: 1,
              borderColor: 'divider',
              justifyContent: 'space-between',
              p: 1,
              // position: 'sticky',
              bottom: 0,
            }}
          >
            <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} sx={{ gap: 0.5 }}>
              <IconButton
                size="small"
                onClick={(event) =>
                  isNewsLiked(news) ? handleUnlikeClick(event, news[0]?._id) : handleLikeClick(event, news[0]?._id)
                }
                sx={{
                  transition: 'color 0.3s ease',
                  color: isNewsLiked(news) ? '#0a4fac' : 'grey',
                  '&:hover': {
                    color: '#73c2fb',
                  },
                }}
              >
                <Tooltip title={isNewsLiked(news) ? 'Unlike' : 'Like'}>
                  {isNewsLiked(news) ? (
                    <ThumbUpSharp sx={{ fontSize: '20px' }} />
                  ) : (
                    <ThumbUpAltOutlined sx={{ fontSize: '20px' }} />
                  )}
                </Tooltip>
              </IconButton>
              <Typography
                variant="body2"
                sx={{
                  cursor: 'default',
                  color: isNewsLiked(news) ? '#0a4fac' : 'grey',
                  fontWeight: 'bold',
                }}
                onClick={(event) => handleLikesClick(event, news[0]?.likes)}
              >
                {news[0]?.likes?.length || 0}
              </Typography>
              <IconButton onClick={() => inputRef.current.focus()}>
                <Tooltip title="Comments">
                  <InsertCommentOutlined sx={{ color: 'grey', fontSize: '20px' }} />
                </Tooltip>
              </IconButton>
              <Typography variant="body2" sx={{ cursor: 'default', color: 'grey', fontWeight: 'bold' }}>
                {news[0]?.comments?.length || 0}
              </Typography>
              <IconButton>
                <Tooltip title="Views">
                  <VisibilityOutlined sx={{ color: 'grey', fontSize: '20px' }} />
                </Tooltip>
              </IconButton>
              <Typography variant="body2" sx={{ cursor: 'default', color: 'grey', fontWeight: 'bold' }}>
                {news[0]?.viewCount?.length || 0}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid
          sx={{
            // borderTop: 1,
            paddingTop: 2,
            borderColor: 'divider',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            // height: '50vh',
            boxShadow: 'none',
            // borderRadius: '10px',
            // border: 1,
            // borderColor: 'divider',
          }}
        >
          {/* add here CHATGPT */}
          {/* <Grid sx={{ p: 2, position: 'sticky', borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Comments
        </Typography>
      </Grid> */}
          <Grid sx={{ overflow: 'hidden' }}>
            {news[0]?.comments?.length > 0 ? (
              news[0]?.comments
                ?.slice()
                ?.reverse()
                ?.map((comment, index) => (
                  <Box
                    key={comment._id}
                    name={`comment-${comment._id}`} // Unique name for each comment
                    id={`comment-${comment._id}`} // Unique ID for each comment
                    sx={{
                      mb: 1.5,
                      p: 2,
                      backgroundColor: 'background.paper',
                      borderRadius: '8px',
                      border: 0.1,
                      borderColor: 'divider',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        mb: 1,
                      }}
                    >
                      <Box display="flex" flexDirection="row" alignItems="center">
                        <Avatar sx={{ width: 32, height: 32, mr: 1  ,img: { objectFit: 'cover', objectPosition: 'top' }}} src={comment?.authorUserPhoto} />
                        <Typography variant="body2" color="black" sx={{ fontWeight: 'bold' }}>
                          {capitalizeFirstLetter(comment.authorName)}
                        </Typography>
                      </Box>
                      <Typography fontSize="10px" color="grey">
                        {new Date(comment.date).toLocaleDateString()} | {new Date(comment.date).toLocaleTimeString()}
                      </Typography>
                    </Box>
                    {user?.empCode === comment?.empCode ? (
                      <Box sx={{ float: 'right' }}>
                        <IconButton variant="outlined" onClick={() => handleDeleteComment(news[0]?._id, comment._id)}>
                          <Delete sx={{ color: 'grey', fontSize: '17px' }} />
                        </IconButton>
                      </Box>
                    ) : null}
                    <Typography fontSize="15px" sx={{ color: 'text.primary', wordBreak: 'break-word' }}>
                      {comment.comment}
                    </Typography>
                  </Box>
                ))
            ) : (
              <Grow in={true} timeout={1000}>
                <Grid
                  container
                  sx={{ display: 'flex', flexDirection: 'column', height: '30vh' }}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Box
                    container
                    hover={hover ? 1 : 0}
                    onMouseEnter={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <img style={{ width: '50%' }} src={empty} alt="Loading..." />
                    <br />
                  </Box>
                  <Typography sx={{ fontSize: '14px', p: 2, color: 'rgba(0,0,0,0.7)' }}>
                    Be the first to comment
                  </Typography>
                </Grid>
              </Grow>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        sx={{
          backgroundColor: 'white',
          marginTop: '5rem',
          p: 1,
          borderTop: 1,
          borderColor: 'divider',
          position: 'fixed',
          poisition: 'absolute',
          bottom: 2,
          left: 0,
          right: 0,
          zIndex: 100,
        }}
      >
        <TextField
          multiline
          size="small"
          fullWidth
          id="comment"
          name="comment"
          inputRef={inputRef}
          value={commentData.comment}
          onChange={handleCommentChange}
          placeholder="Type a comment..."
          variant="outlined"
          maxRows={7}
          // onKeyPress={(event) => handleKeyPress(event)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton onClick={handleEmojiPopover} edge="start">
                  <EmojiEmotions />
                </IconButton>
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  disabled={sendDisable}
                  onClick={() => {
                    if (commentData.comment.trim() !== '') {
                      handleCommentPost(news[0]._id);
                      if (inputRef.current) inputRef.current.focus();
                    }
                  }}
                  edge="end"
                >
                  <Send />
                </IconButton>
              </InputAdornment>
            ),
          }}
          minRows={1}
          sx={{ borderRadius: '8px', boxShadow: 'none' }}
        />
        <Popover
          id="emoji-picker-popover"
          open={open}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <EmojiPicker onEmojiClick={handleEmojiClick} />
        </Popover>
      </Grid>
    </Grid>
  );
};

export default NewsComments;
